import {__} from '@wordpress/i18n';
import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import {decodeEntities} from '@wordpress/html-entities';
import {getSetting} from '@woocommerce/settings';
import OneyCheckoutWidget from './helper/wc-payplug-oney-checkout-widget';

const settings = getSetting('oney_x3_with_fees_data', {});
const defaultLabel = __('Gateway method title', 'payplug');
const label = decodeEntities(settings?.title) || defaultLabel;

const Content = () => {
	return <OneyCheckoutWidget settings={settings} />;
};

/**
 * Label component
 *
 */
const Label = () => {
	return (
		<span style={{width: '100%'}}>
            {label}
			<Icon/>
        </span>
	)
}

const Icon = () => {
	return (
		<img src={settings?.icon.src} alt={settings?.icon.alt} className={settings.icon.class}
			 style={{float: 'right'}}/>
	)
}

/**
 * Payplug payment method config object.
 */
let oney_x3_with_fees = {
	name: "oney_x3_with_fees",
	label: <Label/>,
	content: <Content/>,
	edit: <Content/>,
	canMakePayment: (props) => {

		if (props.cart.cartItemsCount > settings?.requirements.max_quantity) {
			return false
		}

		if ((props.cartTotals.total_price > settings?.requirements.max_threshold) ||
			(props.cartTotals.total_price < settings?.requirements.min_threshold)) {
			return false;
		}

		return settings?.requirements.allowed_country_codes.indexOf(props.shippingAddress.country) !== -1;
	},
	ariaLabel: label,
	supports: {
		features: settings.supports,
	},
};

registerPaymentMethod(oney_x3_with_fees);


/**
 * Cart page Oney logo
 */
(() => {
	// Only proceed if Oney is enabled in settings
	// Only initialize if we're on the cart page
	if (!!window?.wp?.data?.select('wc/store/cart') &&
		document.body.classList.contains('woocommerce-cart')) {
		// Check if Oney is enabled in settings - if not, exit immediately

		if (settings?.enabled !== true) {
			// Clean up any existing container
			const container = document.querySelector('.payplug-totals-container');
			if (container) {
				container.remove();
			}
			return;
		}
		const { createElement } = window.wp.element;
		const { select } = window.wp.data;
		const { createRoot } = require('react-dom/client');
		let root = null;
		const createCustomElement = () => {

			// Get cart total
			const cartStore = select('wc/store/cart');
			let cartTotal = cartStore?.getCartTotals()?.total_price || 0;
			let qty = 0;

			cartStore?.getCartData().items.forEach((item) => {
				qty += item.quantity;
			});

			let oney_available = false;
			// Only show Oney as available if it's enabled and cart total is within limits
			if (settings?.enabled === true &&
				(cartTotal >= settings?.requirements['min_threshold']) &&
				(cartTotal <= settings?.requirements['max_threshold']) &&
				(qty <= settings?.requirements['max_quantity'])) {
				oney_available = true;
			}

			// Only return an element if Oney is available
			if (!oney_available) {
				return null;
			}

			const openSimulation = () => {
				if (typeof window.loadOneyWidget !== 'function' || !settings?.oney_widget?.business_transaction_codes) {
					return;
				}

				const options = {
					...settings.oney_widget,
					payment_amount: cartTotal / 100,
					filter_by: 'business_transaction_codes',
					errorCallback: (status, response) => {
						console.warn('Oney widget unavailable', status, response);
					},
				};

				window.loadOneyWidget(() => {
					if (typeof window.oneyMerchantApp === 'undefined') {
						return;
					}
					window.oneyMerchantApp.loadSimulationPopin({options});
				});
			};

			return createElement('div',
				{
					className: 'wc-block-components-totals-item payplug-oney',
					style: {
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						cursor: 'pointer',
					},
					onClick: openSimulation,
				},
				[
					createElement('div',
						{
							key: 'oney-message',
							className: 'oney-message',
							style: {
								display: 'flex',
								alignItems: 'center',
								gap: '8px'
							}
						},
						settings.oney_cart_label
					),
					createElement('img', {
						key: 'oney-logo',
						src: settings?.oney_cart_logo,
						alt: 'Oney Payplug',
						// Not "oney-3x4x": that class also drives a CSS background-image on the
						// classic (non-block) badge's empty <div>, which collides with this plain
						// <img src> and renders two overlapping, differently-sized logos.
						className: 'oney-cart-logo-img',
						style: {
							maxWidth: '50%',
							height: 'auto',
							display: 'block',
							margin: '10px 0'
						}
					})
				]
			);
		};

		const renderCustomContent = () => {
			try {
				// Check if Oney is enabled and conditions are met
				const cartStore = select('wc/store/cart');
				let cartTotal = cartStore?.getCartTotals()?.total_price || 0;
				let qty = 0;

				cartStore?.getCartData().items.forEach((item) => {
					qty += item.quantity;
				});

				// Verify if Oney should be displayed
				const shouldDisplayOney = settings?.enabled === true &&
					(cartTotal >= settings?.requirements['min_threshold']) &&
					(cartTotal <= settings?.requirements['max_threshold']) &&
					(qty <= settings?.requirements['max_quantity']);

				const cartTotalsBlock = document.querySelector('.wc-block-components-totals-wrapper');
				let container = document.querySelector('.payplug-totals-container');

				// If Oney should not be displayed, remove the container if it exists
				if (!shouldDisplayOney) {
					if (container) {
						container.remove();
						root = null;
					}
					return;
				}

				if (cartTotalsBlock) {
					// Look for existing container
					const totalsWrapper = document.querySelector('.wc-block-components-totals-wrapper');

					// Create container if it doesn't exist and Oney should be displayed
					if (!container && shouldDisplayOney) {
						container = document.createElement('div');
						container.className = 'payplug-totals-container';
						totalsWrapper.insertBefore(container, totalsWrapper.firstChild);
						root = createRoot(container);
					}

					// Use regular render
					if (root && shouldDisplayOney) {
						root.render(createCustomElement());
					}
				}
			} catch (error) {
				console.error('Render error:', error);
			}
		};

		// Initial setup - only if Oney is enabled
		if (settings?.enabled === true) {
			const observer = new MutationObserver((mutations, obs) => {
				if (document.querySelector('.wc-block-components-totals-wrapper') && window.wc?.blocksCheckout) {
					obs.disconnect();
					renderCustomContent();

					// Subscribe to store changes
					wp.data.subscribe(() => {
						const cartStore = select('wc/store/cart');
						const cartTotals = cartStore?.getCartTotals();
						if (cartTotals) {
							renderCustomContent();
						}
					});
				}
			});

			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
		} else {
			// If Oney is not enabled, clean up any existing containers
			const container = document.querySelector('.payplug-totals-container');
			if (container) {
				container.remove();
			}
		}
	}

})();